/**
 * The one-time "Snabbsök moved" hint under the question's text link — the
 * knobs, in a dependency-free module so the component
 * (`app/components/snabb-sok.tsx`) and the Playwright suite
 * (`tests/e2e/snabbsok.test.ts`) read the SAME values. Keep this file free of
 * React/DOM imports: Playwright loads it in Node.
 *
 * The hint helps people who knew the card at the top find it under the
 * question. It shows at most once per browser (localStorage) and only until
 * MOVED_HINT_UNTIL, roughly a week after the move shipped: on shared computers
 * it would otherwise reappear for every new user indefinitely. After the date
 * the code is inert and can be removed.
 */

export const MOVED_HINT_KEY = 'snabbsok-flyttad-hint-seen'

/** Shown up to (not including) this moment. */
export const MOVED_HINT_UNTIL = Date.parse('2026-10-29T00:00:00+01:00')

export const movedHintActive = (now: number = Date.now()): boolean =>
	now < MOVED_HINT_UNTIL
